/**
 * Cross Sell banners component.
 *
 * @module app/components/crossSell/games/GamesBanners
 */
import jQuery from 'jquery';
import MobileDetect from '../../MobileDetect';
import Translator from '../../Translator';

/**
 * Binds event handlers
 *
 * @returns {void}
 *
 * @private
 */
var bindEvents = function bindEvents() {

    jQuery('body')
        .on('click', '.banner.-roulette', updateRoulette)
        .on('click', '.banner.-blackjack', updateBlackjack);
};

/**
 * isDevice
 *
 * @returns {{ Android: , BlackBerry: , iOS:, Windows:, any: }}
 *
 * @private
 */
var isDevice = MobileDetect.init();

/**
 * URLs for each game/device
 *
 * @type {Object}
 *
 * @private
 */
var deviceOptions = {
    roulette: {
        name: Translator.translate('components.gameBanners.game.roulette'),
        iOS: {
            url: 'https://mobilegaming.williamhill.com/launch/vegas2/MayfairRouletteMobile?code=R6EN',
            popup: false,
        },
        Android: {
            url: 'http://ads2.williamhill.com/redirect.aspx?co=2&lpid=1487411213&bid=1487410760',
            popup: false,
        },
        default: {
            url: 'http://vegas.williamhill.com/minilobby/?ref=sportbook#R4',
            popup: true,
        },
    },

    blackjack: {
        name: Translator.translate('components.gameBanners.game.blackjack'),
        iOS: {
            url: 'http://ads2.williamhill.com/redirect.aspx?co=2&lpid=1487411214&bid=1487410760',
            popup: false,
        },
        Android: {
            url: 'http://ads2.williamhill.com/redirect.aspx?co=2&lpid=1487411214&bid=1487410760',
            popup: false,
        },
        default: {
            url: 'http://vegas.williamhill.com/minilobby/?ref=sportbook#B8',
            popup: true,
        },
    },
};

/**
 * Loads url or popup based on if the device is Android or not
 *
 * @params  {Object} game   game object
 *
 * @returns {void}
 *
 * @private
 */
var isAndroid = function isAndroid(game) {

    if (isDevice.Android()) { // eslint-disable-line new-cap
        window.location.href = game.Android.url;
    } else {
        window.open(
            game.default.url,
            game.name,
            'toolbar=no,width=799,height=600,resizable=no,menubar=no,status=no,location=no,toolbar=no'
        );
    }
};

/**
 * Loads url or popup
 *
 * @params  {Object} game   game object
 *
 * @returns {void}
 *
 * @private
 */
var popUp = function popUp(game) {

    if (isDevice.iOS()) {
        window.location.href = game.iOS.url;
    } else {
        isAndroid(game);
    }
};

/**
 * Update roulette
 *
 * @param   {Object} e
 *
 * @returns {void}
 *
 * @private
 */
var updateRoulette = function updateRoulette(e) {

    popUp(deviceOptions.roulette);
    e.preventDefault();
};

/**
 * Update blackjack
 *
 * @param   {Object} e
 *
 * @returns {void}
 *
 * @private
 */
var updateBlackjack = function updateBlackjack(e) {

    popUp(deviceOptions.blackjack);
    e.preventDefault();
};

/**
 * Methods to be public
 *
 * @type {Object}
 *
 * @private
 */
var api = {

    // TODO: is this exposed only because of the tests?
    oldBanners: {
        popUp: popUp,
    },

    /**
     * Perform initialisation.
     *
     * Initialisation carried out depends on whether new or old banners
     * config is being used.
     *
     * @returns {void}
     *
     * @public
     */
    init: function init() {

        if (window.WH.sportsbook.crossBannerMode === 'old') {
            bindEvents();
        }
    },
};

export default api;
